import React, { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form'

import Typography from 'components/atoms/Typography'
import CustomButton from 'components/atoms/CustomButton'
import { flatten } from 'helpers/array'

import './FilterButtonMobile.scss'

function FilterButtonMobile({ text, onSubmit, items, selectAllText, oneOption }) {
  const [active, setActive] = useState(false)
  const [values, setValues] = useState(flatten(items?.map(getSelectedValues) || []))
  const handleClose = () => setActive(false)
  const handleShow = () => setActive(true)

  const handleChange = (value, target, field) => {
    if (target?.checked) {
      addValue(value, field)
    } else {
      removeValue(value, field)
    }
  }
  const handleSubmit = () => {
    if (onSubmit) onSubmit(values)
    handleClose()
  }

  function addValue(value, field) {
    setValues((values) => {
      const currentValues = oneOption ? values.filter((value) => value.field != field) : values
      const newValues = field ? { value, field } : value
      return [...currentValues, { ...newValues, selected: true }]
    })
  }

  function getSelectedValues({ items, field }) {
    return items?.map((subitem) => subitem.selected && { ...subitem, field }).filter((item) => item)
  }

  function removeValue(value, field) {
    setValues((values) => {
      if (field)
        return values.map((currentVal) =>
          !(currentVal?.value === value && currentVal?.field === field) ? currentVal : { field, value: undefined }
        )
      return values.filter((currentVal) => !(currentVal === value))
    })
  }

  // block scroll
  useEffect(() => {
    const body = document.querySelector('body')
    if (active === false) {
      body.style.overflowY = 'auto'
    } else {
      body.scrollTo(0, 0)
      body.style.overflowY = 'hidden'
    }
  }, [active])

  return (
    <>
      <button className="FilterButtonMobile" onClick={handleShow}>
        <i className="icone-options ml-2" />
        <span>{text}</span>
      </button>

      <section className={`filterModal d-lg-none ${active ? 'active' : ''}`}>
        <nav aria-label="Filtrar por" className={`filterModal-menu ${active ? 'active' : ''}`}>
          <section className="filterModal-menu-header">
            <button onClick={handleClose}>
              <i className="icone-arrow-left" />
            </button>
            <Typography variant="h6" color="primary">
              Filtrar por
            </Typography>
          </section>

          {Array.isArray(items) &&
            items
              .filter((i) => Array.isArray(i.items))
              .map((item, key) => (
                <details className="filterModal-menu-drop" open={items.length === 1} key={key}>
                  <summary>{item.name}</summary>
                  <nav aria-label="Opções de filtro">
                    <ul>
                      <Form.Group>
                        {Array.isArray(item.items) &&
                          item.items.map((subitem, key) => (
                            <li key={key}>
                              <span className="filterModal-menu-link" title={subitem.name}>
                                <Form.Check
                                  checked={!!values.find(({ value }) => value === subitem.value)}
                                  onChange={({ target }) => handleChange(subitem.value, target, item.field)}
                                  radioGroup="filters"
                                  type="checkbox"
                                />
                                {subitem.name}
                              </span>
                            </li>
                          ))}
                      </Form.Group>
                    </ul>
                  </nav>
                </details>
              ))}

          <nav aria-label="Resultados do filtro" className="filterModal-menu-drop">
            <ul>
              {selectAllText && (
                <li>
                  <Form.Group controlId={'filters-all'} className="filterModal-menu-link">
                    <Form.Check
                      type="checkbox"
                      label={selectAllText}
                      value={''}
                      checked={Array.isArray(values) && values.length === 0}
                      onChange={(e) => handleChange(e.target?.value)}
                    />
                  </Form.Group>
                </li>
              )}

              {Array.isArray(items) &&
                items
                  .filter((i) => !Array.isArray(i.items))
                  .map((item, key) => {
                    const checked = Array.isArray(values) && values.find((i) => i === item.value.toString())

                    return (
                      <li key={key}>
                        <Form.Group controlId={'filters' + key} className="filterModal-menu-link">
                          <Form.Check
                            type="checkbox"
                            label={item.name}
                            value={item.value}
                            checked={checked || false}
                            onChange={(e) => handleChange(e.target.value, e.target)}
                          />
                        </Form.Group>
                      </li>
                    )
                  })}
            </ul>
          </nav>

          <section className="filterModal-menu-footer">
            <div className="filterModal-menu-footer-buttons">
              <CustomButton color={`outline-primary`} text="Fechar" onClick={handleClose} className="mr-2" noIcon />
              <CustomButton
                className="filterModal-menu-footer-primary-btn"
                text="Filtrar"
                onClick={handleSubmit}
                noIcon
              />
            </div>
          </section>
        </nav>
      </section>
    </>
  )
}

export default FilterButtonMobile
